import { useContext, useEffect, useState } from "react";
import { CardType } from "../../../../util/enums";
import { CardContext } from "../../../../context";

const useShowDrawnStrengthCard = (player: any) => {
    const { drawSolutionCard } = useContext(CardContext);
    
    const [isEmotionalUsed, setIsEmotionalUsed] = useState<boolean>(false);
    const [isPhysicalUsed, setIsPhysicalUsed] = useState<boolean>(false);
    const [isRelationsUsed, setIsRelationsUsed] = useState<boolean>(false);
    const [isMentalUsed, setIsMentalUsed] = useState<boolean>(false);

    useEffect( () => { 
        if(player?.currentSolutionCards["Emotional"] && !isEmotionalUsed){ 
            drawSolutionCard({
                id: player?.currentSolutionCards["Emotional"]._id,
                type: CardType.EMOTIONAL_SOLUTION,
                backImagePath: "https://opengameart.org/sites/default/files/card%20back%20green.png",
                title: player?.currentSolutionCards["Emotional"].title,
                content: player?.currentSolutionCards["Emotional"].description,
                link: player?.currentSolutionCards["Emotional"].info
            })
            setIsEmotionalUsed(true);
        }
    }, [drawSolutionCard, isEmotionalUsed, player?.currentSolutionCards]);

    useEffect( () => {
        if(player?.currentSolutionCards["Physical"] && !isPhysicalUsed){ 
            drawSolutionCard({
                //Tag
                id: player?.currentSolutionCards["Physical"]._id,
                type: CardType.PHYSICAL_SOLUTION,
                backImagePath: "https://opengameart.org/sites/default/files/card%20back%20green.png",
                title: player?.currentSolutionCards["Physical"].title,
                content: player?.currentSolutionCards["Physical"].description,
                link: player?.currentSolutionCards["Physical"].info
            })
            setIsPhysicalUsed(true);
        }
    }, [drawSolutionCard, isPhysicalUsed, player?.currentSolutionCards]);

    useEffect( () => {
        if(player?.currentSolutionCards["Relations"] && !isRelationsUsed){ 
            drawSolutionCard({
                id: player?.currentSolutionCards["Relations"]._id,
                type: CardType.SOCIAL_SOLUTION,
                backImagePath: "https://opengameart.org/sites/default/files/card%20back%20green.png",
                title: player?.currentSolutionCards["Relations"].title,
                content: player?.currentSolutionCards["Relations"].description,
                link: player?.currentSolutionCards["Relations"].info
            })
            setIsRelationsUsed(true);
        }
    }, [drawSolutionCard, isRelationsUsed, player?.currentSolutionCards]);

    useEffect( () => {
        if(player?.currentSolutionCards["Mental"] && !isMentalUsed){ 
            drawSolutionCard({
                id: player?.currentSolutionCards["Mental"]._id,
                type: CardType.MENTAL_SOLUTION,
                backImagePath: "https://opengameart.org/sites/default/files/card%20back%20green.png",
                title: player?.currentSolutionCards["Mental"].title,
                content: player?.currentSolutionCards["Mental"].description,
                link: player?.currentSolutionCards["Mental"].info
            })
            setIsMentalUsed(true);
        }
    }, [drawSolutionCard, isMentalUsed, player?.currentSolutionCards]);

  };
  
  export default useShowDrawnStrengthCard;
  